import React, { memo } from 'react';

import { List, ListItem, makeSelectable } from 'material-ui/List';

const SelectableList = makeSelectable(List);

const UserList = memo(props => {
	const { userId, users, onChange } = props;
	return (
		<SelectableList value={userId}>
			{users.map((edge, index) => (
				<ListItem key={index} value={edge.node._id} primaryText={edge.node.name} onClick={e => onChange(edge.node)} />
			))}
		</SelectableList>
	);
});

export default UserList;



// WEBPACK FOOTER //
// src/components/stats/UserList.js